import withRouter from "hoc/withRouter";
import {
  Chip,
  CircularProgress,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import ListPage from "components/ListPage/ListPage";
import counterpartiesService from "services/admin/counterpartiesService";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { FaTrashAlt } from "react-icons/fa";
import { FaPencil } from "react-icons/fa6";

const CounterpartyList = () => {
  const orgID = localStorage.getItem("orgID") || "";
  const {
    data: counterpartiesResponse,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ["baggage-counterparties", { orgID }],
    queryFn: async () => {
      const response: any = await counterpartiesService.getAll();
      return response.data;
    },
  });

  const handleDelete = async (id: string) => {
    if (!window.confirm("Удалить контрагента?")) return;
    await counterpartiesService.delete(id);
    refetch();
  };

  function buildContent() {
    if (isLoading) {
      return (
        <div className="text-center">
          <CircularProgress></CircularProgress>
        </div>
      );
    }
    const rows: any[] = (counterpartiesResponse as any)?.data || [];
    if (rows.length === 0) {
      return (
        <div>Контрагенты отсутствуют. Чтобы добавить контрагента, нажмите на кнопку "Добавить" сверху</div>
      );
    }
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>#</TableCell>
            <TableCell>Наименование</TableCell>
            <TableCell>БИН/ИИН</TableCell>
            <TableCell>Контакт</TableCell>
            <TableCell>Договор</TableCell>
            <TableCell>Статус</TableCell>
            <TableCell>Действия</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((c: any, index: number) => (
            <TableRow key={c.id}>
              <TableCell>{index + 1}</TableCell>
              <TableCell>{c.name}</TableCell>
              <TableCell>{c.bin}</TableCell>
              <TableCell>
                {c.contactPerson}
                {c.phone ? ` · ${c.phone}` : ""}
              </TableCell>
              <TableCell>{c.contractNumber}</TableCell>
              <TableCell>
                {c.isActive ? (
                  <Chip label="Активен" color="success" size="small" />
                ) : (
                  <Chip label="Неактивен" size="small" />
                )}
              </TableCell>
              <TableCell>
                <div className="flex gap-2 items-center">
                  <Link to={`/admin/baggages/counterparties/edit/${c.id}`}>
                    <FaPencil />
                  </Link>
                  <IconButton color="error" onClick={() => handleDelete(c.id)}>
                    <FaTrashAlt />
                  </IconButton>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  }
  return (
    <ListPage pageTitle="Контрагенты" pathToAdd={`/admin/baggages/counterparties/add`}>
      <div className="m-t-32">{buildContent()}</div>
    </ListPage>
  );
};

export default withRouter(CounterpartyList);
